<template lang="html">
    <section class="section-form" id="contact-form">
        <div class="row">
            <h2>We're happy to hear from you</h2>
        </div>
        <div class="row">
            <div class="contact-form">
                <div class="row">
                    <div class="col span-1-of-3">
                        <label for="name">Name</label>
                    </div>
                    <div class="col span-2-of-3">
                        <input
                            v-model="name"
                            type="text"
                            name="name"
                            id="name"
                            placeholder="Your name"
                            required>
                    </div>
                </div>
                <div class="row">
                    <div class="col span-1-of-3">
                        <label for="email">Email</label>
                    </div>
                    <div class="col span-2-of-3">
                        <input
                            v-model="email"
                            type="email"
                            name="email"
                            id="email"
                            placeholder="Your email"
                            required>
                    </div>
                </div>
                <div class="row">
                    <div class="col span-1-of-3">
                        <label>&nbsp;</label>
                    </div>
                    <div class="col span-2-of-3">
                        <a
                            href="#"
                            class="btn btn-full"
                            @click.prevent="save">Send it!</a>
                    </div>
                </div>
            </div>
        </div>

        <!-- waypoint handler functions -->
        <v-waypoint
        @waypoint-in="$store.dispatch('updateSticky')"
        @waypoint-out="$store.dispatch('updateSticky')"
        ></v-waypoint>
    </section>
</template>

<script>
import { db } from '../../store/firebase';
let email_list_ref = db.ref('emailList');

export default {
     data() {
        return {
            name: '',
            email: ''
        }
     },
     methods: {
        save() {
            let email_re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let name_re = /^[A-Za-z]+$/;
            if (name_re.test(this.name)) {
                if (email_re.test(this.email)) {
                    // push data to firebase
                    email_list_ref.push({
                        name: this.name,
                        email: this.email,
                        status: false
                    });
                    // reset data
                    this.name = '';
                    this.email = '';
                    alert("Your information is carefully saved! We will contact you later");
                } else {
                    alert('Please input correct email');
                    return;
                }
            } else {
                alert('Please input correct name');
                return;
            }
        }
     },
     firebase: {
         email_list: email_list_ref
     }
}
</script>

<style lang="scss" scoped>
@import "../../assets/resources/css/partials/variables";

.contact-form {
    width: 60%;
    margin: 2rem auto;

    @media only screen and (max-width: $small-screen) {
        width: 100%;
    }
}

input[type=text],
input[type=email],
select,
textarea {
    width: 100%;
    padding: 7px;
    border-radius: 3px;
    border: 1px solid #ccc;
}

textarea {
    height: 100px;
}

input[type=checkbox] {
    margin: 10px 5px 10px 0;
}

*:focus {outline: none;}
</style>



// WEBPACK FOOTER //
// Contact.vue?f3953716